import { Controller } from "@hotwired/stimulus"

// Keeps a color swatch and its hex text input in sync. Both inputs share the
// same name, so a coherent value is always submitted regardless of which the
// seller edited.
export default class extends Controller {
  static targets = ["swatch", "hex"]

  fromSwatch() {
    this.hexTarget.value = this.swatchTarget.value
  }

  fromHex() {
    if (/^#[0-9a-fA-F]{6}$/.test(this.hexTarget.value.trim())) {
      this.swatchTarget.value = this.hexTarget.value.trim()
    }
  }
}
